import {Box, Button, DialogActions} from "@mui/material";
import {theme} from "../../../../../_fri/themes/theme";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
interface IModalPaymentRejected {
    close: () => void,
}

export const EcommerceDashboardModalPaymentRejected = ({close}:IModalPaymentRejected) => {
    return (
        <>
            <Box sx={{marginTop: "2rem", marginBottom: "0.7rem"}}>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <CancelOutlinedIcon color='error' sx={{fontSize:"7rem"}}/>
                </Box>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <Box sx={{textAlign: "center", color: theme.palette.common.black}}>
                        <Box>
                            La solicitud de pago fue rechazada
                        </Box>
                        <Box>
                            por el usuario, intenta nuevamente o
                        </Box>
                        <Box>
                            confirma la información del cobro.
                        </Box>
                    </Box>
                </Box>
            </Box>
            <DialogActions sx={{justifyContent: "center", marginBottom: "1rem"}}>
                <Button
                    sx={{
                        width: "6.5rem",
                        height: "3rem",
                        borderRadius: "0.5rem",
                    }}
                    color={"error"}
                    variant={"contained"}
                    onClick={close}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </>
    );
};